import { faFacebook, faGithub, faInstagram, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-top">
        <div className="footer-content">
          <div className="footer-top-row">
            <p className="footer-title">STAY UPTO DATE ABOUT</p>
            <div className="footer-input-container">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="footer-input-icon"
              />
              <p className="footer-input-text">Enter your email address</p>
            </div>
          </div>

          <div className="footer-top-row">
            <p className="footer-title">OUR LATEST OFFERS</p>
            <p className="footer-subscribe">Subscribe to Newsletter</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-section">
          <h2 className="footer-section-title">SHOP.CO</h2>
          <p className="footer-description"> we have clothes that suits your style and <br /> which you're proud to wear, From <br /> women to men.</p>

          <div className="footer-social-icons">
            <a className="footer-link-icon" href="https://x.com/shopco144919" target="_blank"> <FontAwesomeIcon className="footer-icon" icon={faTwitter} /></a>
            <a className="footer-link-icon" href="https://www.youtube.com/channel/UCu_S20xTdjirfws3hJYpCuA" target="_blank"> <FontAwesomeIcon className="footer-icon" icon={faYoutube} /></a>
            <a className="footer-link-icon" href="https://www.instagram.com/shopco2025/" target="_blank"> <FontAwesomeIcon className="footer-icon" icon={faInstagram} /></a>
            <a className="footer-link-icon" href="https://github.com/shopco2025" target="_blank"><FontAwesomeIcon className="footer-icon" icon={faGithub} /></a>
          </div>
        </div>

        <div>
          <h3 className="footer-column-title">COMPANY</h3>
          <div>
            <Link to="/company/about-us" className="footer-column-item" >about us</Link>
            <Link to="/company/features" className="footer-column-item">Features</Link>
            <Link to="/company/works" className="footer-column-item">Works</Link>
            <Link to="/company/career" className="footer-column-item">Career</Link>
          </div>
        </div>

        <div>
          <h3 className="footer-column-title">HELP</h3>
          <div>
            <Link to="/help/customers-support" className="footer-column-item">Customers Support</Link>
            <Link to="/help/delivery-details" className="footer-column-item">Delivery Details</Link>
            <Link to="/help/terms-conditions" className="footer-column-item">Term & Conditions</Link>
            <Link to="/help/privacy-policy" className="footer-column-item">Privacy Policy</Link>
          </div>
        </div>

        <div>
          <h3 className="footer-column-title">FAQ</h3>
          <div>
            <Link to="/FAQ/Account" className="footer-column-item">Account</Link>
            <Link to="/FAQ/manage-deliveries" className="footer-column-item">Manage Deliveries</Link>
            <Link to="/FAQ/orders" className="footer-column-item">Orders</Link>
            <Link to="/FAQ/payment" className="footer-column-item">Payments</Link>
          </div>
        </div>

        <div>
          <h3 className="footer-column-title">RESOURCES</h3>
          <div>
            <Link to="/resources/ebooks" className="footer-column-item">Free eBooks</Link>
            <Link to="/resources/development-tutorial" className="footer-column-item">Development Tutorial</Link>
            <Link to="/resources/how-to-blog" className="footer-column-item">How to -BLog</Link>
            <Link to="/resources/youtube-play-list" className="footer-column-item">Youtube Playlist</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
